import React, { Component } from 'react';
import {connect} from "react-redux";
import Statistics from "../../components/Statistics/Statistics";
import * as actions from "../../actions";

class StatisticsHOC extends Component{
    componentDidMount() {
        // Fetch all chat data for client-side filtering
        this.props.fetchPendingChats();
        this.props.fetchActiveChats();
        this.props.fetchHistoryChats({sendBody: {page: 1}});
    }

    render() {
        const allChats = [
            ...(this.props.pendingChats || []),
            ...(this.props.activeChats || []),
            ...(this.props.historyChats || [])
        ];

        return (
            <Statistics
                {...this.props}
                allChats={allChats}
                loginsCharts={{title: 'Logins',
                    data: [this.props.stats.returningChats || 0, this.props.stats.newChats || 0],
                    dataLabels: ['Returning','New']}}
                agesCharts={{title: 'Ages',
                    dataLabels :['11-', '12', '13', '14', '15', '16', '17', '18+'],
                    datasetLabel:'Age',
                    bgColor:'#6197e9',
                    borderColor:'#6164ff'}}
            />

        );
    }
}

const mapStateToProps = state => {
    return {
        stats: state.statistics.stats,
        loadingStats: state.statistics.loading,
        pendingChats: state.chats.pendingChatsIds.map(id => state.chats.byId[id]).filter(Boolean),
        activeChats: state.chats.activeChatsIds.map(id => state.chats.byId[id]).filter(Boolean),
        historyChats: state.chats.historyChatsIds.map(id => state.chats.byId[id]).filter(Boolean),
        childUsers: state.childUsers.byId,
        feelingsCodes: state.general.feelings
    }
};

const mapDispatchToProps = dispatch => {
    return {
        fetchPendingChats: () => dispatch(actions.fetchPendingChats()),
        fetchActiveChats: () => dispatch(actions.fetchActiveChats()),
        fetchHistoryChats: (payload) => dispatch(actions.fetchHistoryChats(payload))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(StatisticsHOC);
